import { useCookie } from "@/composable/useCookie";

const publicRoutes = ['auth/login', 'auth/forgot-password', 'set-password'];

export default defineNuxtRouteMiddleware((to, from) => {
    if (process.client) {
        const { getCookie } = useCookie();
        const accessToken = getCookie("accessToken");

        const toPath = to.path.replace(/^\/|\/$/g, '');
        const isShortLink = /^[a-zA-Z0-9]{6}$/.test(toPath);
        const isPublicPage = publicRoutes.includes(toPath);
        const hasAccess = !!accessToken;

        if (isShortLink) {
            return;
        }

        if (!hasAccess && !isPublicPage) {
            return navigateTo('/auth/login');
        }

        if (hasAccess && isPublicPage) {
            return navigateTo('/');
        }
    }
})